import { all, takeLatest, put, call, fork } from "redux-saga/effects";
import { actions, constants } from "./actions";
import { apiV2 } from "../../services/api";
import { fetchOrSelectCallTakers } from "../callTakers/sagas";

const { shiftAssignments: shiftAssignmentsApi } = apiV2;
const { CREATE_SHIFT_ASSIGNMENT } = constants;

// Action sagas - async
function* getScheduleRequest() {
  yield takeLatest("GET_SCHEDULE/REQUEST", function* ({ payload }) {
    try {
      const shiftAssignments = yield call(shiftAssignmentsApi.getAll, payload);
      const callTakers = yield call(fetchOrSelectCallTakers);
      yield put(actions.getSchedule.success({ shiftAssignments, callTakers }));
    } catch (err) {
      yield put(
        actions.getSchedule.failure({
          message: "Failed to retrieve page, please try again.",
        })
      );
    }
  });
}

function* createShiftAssignmentRequest() {
  yield takeLatest("CREATE_SHIFT_ASSIGNMENT/REQUEST", function* ({ payload }) {
    try {
      const shiftAssignment = yield call(shiftAssignmentsApi.create, payload);
      yield put(
        actions.createShiftAssignment.success({
          message: "Successfully scheduled shift.",
          shiftAssignment,
          source: CREATE_SHIFT_ASSIGNMENT,
        })
      );
    } catch (err) {
      yield put(
        actions.createShiftAssignment.failure({
          source: CREATE_SHIFT_ASSIGNMENT,
          message: "Unable to create schedule item, please try again.",
        })
      );
    }
  });
}

function* removeScheduleItemRequest() {
  yield takeLatest("REMOVE_SCHEDULE_ITEM/REQUEST", function* ({ payload }) {
    try {
      yield call(shiftAssignmentsApi.delete, payload.id);
      yield put(
        actions.removeScheduleItem.success({
          message: "Successfully removed scheduled shift.",
          deletedShiftAssignmentId: payload.id,
        })
      );
    } catch (err) {
      yield put(
        actions.removeScheduleItem.failure({
          message: "Unable to remove schedule item, please try again.",
        })
      );
    }
  });
}

// Watcher sagas
export default function* rootSaga() {
  yield all([
    fork(getScheduleRequest),
    fork(createShiftAssignmentRequest),
    fork(removeScheduleItemRequest),
  ]);
}
